/* src/app/components/doc-viewer-new/dialogs/open-ai-setting-dialog-new/open-ai-setting-dialog-new.component.scss */
[dialog-body] {
  color: var(--text-color);
}
:host-context(.dark-theme) [dialog-body] {
  color: var(--text-color);
}
a {
  color: #fff;
}
.form-container {
  display: flex;
  flex-direction: column;
}
.form-container > label {
  color: #3949AB;
  font-weight: 500;
  display: block;
  margin-bottom: 2px;
}
.input-hint {
  font-size: 11px;
  padding-left: 4px;
  color: rgba(0, 0, 0, 0.6);
}
.input-hint-link {
  color: rgba(0, 0, 0, 0.6);
}
:host-context(.dark-theme) .form-container > label {
  color: #FFC107;
}
:host-context(.dark-theme) .input-hint {
  color: rgba(255, 255, 255, 0.7019607843);
}
:host-context(.dark-theme) .input-hint-link {
  color: rgba(255, 255, 255, 0.7019607843);
}
.form-group {
  flex: 1;
}
.dark-theme-option {
  background-color: #424242 !important;
  color: #FFFFFF !important;
}
.dark-theme-option:hover {
  background-color: #424242 !important;
  opacity: 0.9 !important;
}
.dark-theme-option:focus {
  background-color: #424242 !important;
  opacity: 0.9 !important;
}
:host-context(.dark-theme) ::placeholder {
  color: rgba(255, 255, 255, 0.5);
}
:host-context(.dark-theme) .mat-mdc-input-element {
  color: #FFFFFF;
  caret-color: #9fa8da !important;
}
/*# sourceMappingURL=open-ai-setting-dialog-new.component.css.map */
